import { useEffect, useRef, useState } from 'react';

// 数字滚动组件：从 0 滚动到目标值，1s easeOutExpo
function easeOutExpo(t) {
  return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
}

export default function StatCounter({ value, suffix = '', prefix = '', duration = 1000 }) {
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !started.current) {
            started.current = true;
            const start = performance.now();
            const animate = (now) => {
              const elapsed = now - start;
              const progress = Math.min(elapsed / duration, 1);
              const current = Math.floor(easeOutExpo(progress) * value);
              setDisplay(current);
              if (progress < 1) {
                requestAnimationFrame(animate);
              } else {
                setDisplay(value);
              }
            };
            requestAnimationFrame(animate);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [value, duration]);

  const formatNumber = (num) => {
    return num.toLocaleString('zh-CN');
  };

  return (
    <span ref={ref}>
      {prefix}
      {formatNumber(display)}
      {suffix}
    </span>
  );
}
